import React from 'react';
import { SHOT_LIST } from './manualContent';
import { DIAGRAMS } from './diagrams';

// A figure in the manual. If a real screenshot named <id>.png (or .jpg/.webp)
// exists in src/Assets/manual/, it is used. Otherwise we draw the built-in
// schematic, and if there isn't one of those either we show the capture
// instruction so it's obvious which shot is still missing.
//
// require.context is resolved by webpack at build time — dropping a correctly
// named file into that folder is the entire wiring step.

let SHOTS = {};
try {
  const ctx = require.context('../../Assets/manual', false, /\.(png|jpe?g|webp)$/);
  ctx.keys().forEach(key => {
    const id = key.replace(/^\.\//, '').replace(/\.(png|jpe?g|webp)$/i, '');
    SHOTS[id] = ctx(key);
  });
} catch {
  SHOTS = {};
}

export function shotCount() {
  return Object.keys(SHOTS).length;
}

export default function ManualFigure({ id, caption }) {
  const shot = SHOTS[id];
  const Diagram = DIAGRAMS[id];
  const spec = SHOT_LIST.find(s => s.id === id);

  return (
    <figure className="mn-figure">
      {shot ? (
        <img className="mn-figure-img" src={shot} alt={caption || id} loading="lazy" />
      ) : Diagram ? (
        <div className="mn-figure-diagram"><Diagram /></div>
      ) : (
        <div className="mn-figure-slot">
          <span className="mn-figure-slot-tag">Screenshot slot</span>
          <strong>{spec?.screen || id}</strong>
          {spec?.capture && <span className="mn-figure-slot-note">{spec.capture}</span>}
          <code>src/Assets/manual/{id}.png</code>
        </div>
      )}
      {caption && <figcaption className="mn-figure-cap">{caption}</figcaption>}
    </figure>
  );
}
